import { generateClient } from 'aws-amplify/api';
import { updateTimeEntry } from "../graphql/customQueries";

const client = generateClient();

export default async ({ id, date, scopeId, hours, isApproved, timeSheetId, crewMemberId, locationId, status, syncStatusMessage }) => {
    try {
        const {
            data: { updateTimeEntry: updatedTimeEntry },
        } = await client.graphql({
            query: updateTimeEntry,
            variables: {
                input: {
                    id,
                    date,
                    scopeId,
                    hours,
                    isApproved,
                    timeSheetId,
                    crewMemberId,
                    locationId,
                    status,
                    syncStatusMessage,
                },
            },
        });
        return updatedTimeEntry;
    } catch (ex) {
        console.error("Failed to update time entry", ex);
    }
};
